import { memo, useEffect, useState } from 'react';

import { FALLBACK_SUBJECT } from 'my-core/course-utils';

import bottomImg from 'images/booklet-preview/bottom.png';
import coverImg from 'images/booklet-preview/cover.png';
import middleImg from 'images/booklet-preview/middle.png';
import logoImg from 'images/logo/logo-on-dark.svg';

const rotationClasses = {
  '& .bottom': { transform: 'rotate(16deg)' },
  '& .middle': { transform: 'rotate(0)' },
  '& .cover': { transform: 'rotate(-16deg)' },
};

export default memo(function CourseBookletImage({ animate, className, onClick, subjectConfig, subtitle, title }) {
  const fallbackCover = !(subjectConfig || subtitle || title);
  subjectConfig ||= FALLBACK_SUBJECT;
  if (subtitle && !title) {
    title = subtitle;
    subtitle = null;
  }
  title ||= 'Course Notes';

  const [fannedOut, setFannedOut] = useState(!animate);
  useEffect(() => {
    const to = setTimeout(() => setFannedOut(true), 2000);
    function handleScroll() {
      clearTimeout(to);
      setFannedOut(true);
    }
    window.addEventListener('scroll', handleScroll, { once: true, passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(to);
    };
  }, []);

  return (
    <div
      className={className}
      css={({ palette, shadows, typography }) => ({
        cursor: onClick ? 'pointer' : 'initial',
        width: '100%',
        maxWidth: '100%',
        position: 'relative',
        '&::before': {
          content: '""',
          display: 'block',
          width: '100%',
          paddingBottom: '86%',
        },
        '& > div': {
          // backgroundColor: 'rgba(255,0,0,0.2)',
          position: 'absolute',
          inset: 0,
          '& > *': {
            position: 'absolute',
            top: '3%',
            width: '57%',
            height: '86.5%',
            left: '20%',
            boxShadow: shadows[8],
            borderRadius: '9%',
            transformOrigin: '40% 110%',
            transform: 'rotate(0)',
            transition: 'transform 0.5s',
          },
          '& .coverWrapper': {
            overflow: 'hidden',
            backgroundImage: `url(${subjectConfig.stockImg.coverSmall}), linear-gradient(${palette.grey[800]}, ${palette.grey[600]})`,
            backgroundSize: 'cover',
            '& > *': { position: 'absolute' },
            '& > .logo': { left: '8%', top: '5%', width: '20%' },
            '& > .content': {
              left: '5%',
              bottom: '20%',
              height: '20%',
              right: 0,
              padding: '4%',
              backgroundColor: palette.common.white,
              '& > svg': {
                width: '100%',
                height: '100%',
                // backgroundColor: 'rgba(0,255,0,0.2)',
                '& text': {
                  fill: palette[subjectConfig.color].main,
                  '&.title': { fontWeight: typography.fontWeightBlack, fontSize: subtitle ? 20 : 24 },
                  '&.subtitle': { fontWeight: typography.fontWeightExtraBold, fontSize: 16 },
                },
              },
            },
            '& > .bar': { left: 0, top: 0, bottom: 0, width: '5%', backgroundColor: palette[subjectConfig.color].main },
          },
          ...(fannedOut && rotationClasses),
          // ...(animate ? { '&:hover': rotationClasses } : rotationClasses)
        },
      })}
      onClick={onClick}
    >
      <div>
        <img className="bottom" src={bottomImg} />
        <img className="middle" src={middleImg} />
        {fallbackCover ?
          <img className="cover" src={coverImg} />
        : <div className="cover coverWrapper">
            <img className="logo" src={logoImg} />
            <div className="content">
              <svg viewBox="0 0 230 50" xmlns="http://www.w3.org/2000/svg">
                {title && (
                  <text className="title" x="0" y={subtitle ? '20' : '35'}>
                    {title}
                  </text>
                )}
                <text className="subtitle" x="0" y="45">
                  {subtitle}
                </text>
              </svg>
            </div>
            <div className="bar" />
          </div>
        }
      </div>
    </div>
  );
});
